import { Component, Input } from '@angular/core';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-download-excel',
  templateUrl: './download-excel.component.html',
  styleUrls: ['./download-excel.component.css']
})
export class DownloadExcelComponent {
  @Input() data: any[] = []; 
  @Input() fileName: string = '';
  @Input() columnsToExport: any[] = []; // Add an input to specify which columns to export

  ngOnChanges() {
    console.log('columnsToExport:', this.columnsToExport);
  }
  

  exportToExcel(): void {
    const columnsToUse = this.columnsToExport && this.columnsToExport.length > 0 ? this.columnsToExport : Object.keys(this.data[0] || {});
  
    // Filter the data based on the columnsToUse
    const filteredData = this.data.map(row => {
      const filteredRow: any = {};
      columnsToUse.forEach(column => {
        if (row.hasOwnProperty(column)) {
          filteredRow[column] = row[column];
        }
      });
      return filteredRow;
    });
  
    // Convert the filtered data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
  
    // Create a workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  
    // Write the file
    XLSX.writeFile(workbook, `${this.fileName}.xlsx`);
  }
  
}
